import React from 'react';
import ListItem from "@material-ui/core/ListItem";
import {Typography} from "@material-ui/core";
import Tooltip from "@material-ui/core/Tooltip";
import Localization from "../../../../config/localization/Localization";
import IconButton from "@material-ui/core/IconButton";
import EditIcon from "@material-ui/icons/Edit";
import SendIcon from "@material-ui/icons/Send";
import PropTypes from "prop-types";
import ListItemText from "@material-ui/core/ListItemText";

const AdminAutocompleteMenuItem = ({suggestion, localizationCode, onEditIntent, onSendIntent, replacedString}) => {
    return (
        <ListItem key={suggestion.id} style={{justifyContent: 'space-between', paddingRight: 0}}>
            <ListItemText primary={
                <Typography style={{ overflow: "wrap" }}>
                    <span dangerouslySetInnerHTML={{__html: replacedString}}></span>
                </Typography>
            }/>
            <div style={{display: 'flex', flexWrap: 'nowrap'}}>
                <Tooltip
                    title={Localization[localizationCode]['chatInput.autoComplete.edit']}
                    aria-label="add"
                >
                    <IconButton onClick={(e) => onEditIntent(suggestion.intentId)}>
                        <EditIcon fontSize="small"/>
                    </IconButton>
                </Tooltip>
                <Tooltip
                    title={Localization[localizationCode]['chatInput.autoComplete.send']}
                    aria-label="add"
                >
                    <IconButton onClick={(e) => onSendIntent(suggestion.intentId)}>
                        <SendIcon fontSize="small"/>
                    </IconButton>
                </Tooltip>
            </div>
        </ListItem>
    );
};

AdminAutocompleteMenuItem.propTypes = {
    localizationCode: PropTypes.string.isRequired,
    suggestion: PropTypes.object.isRequired,
    replacedString: PropTypes.string.isRequired,
    onSendIntent: PropTypes.func.isRequired,
    onEditIntent: PropTypes.func.isRequired,
}

export default AdminAutocompleteMenuItem;